import { Badge, Card, ConfigProvider, Popover, Space, Table, theme, Tooltip, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import dayjs from 'dayjs'
import { FC, memo } from 'react'
import { styled } from 'styled-components'
import formatDuration from '../../../../../helpers/date-time/format-duration'
import formatNumber from '../../../../../helpers/formatters/format-any-number'
import { PrintPlanDateGroup } from '../../helpers/build-print-plan-date-groups'

const CardStyled = styled(Card)<{ $isActive: boolean; $compact: boolean; token?: any }>`
    flex: ${({ $compact }) => ($compact ? '0 0 auto' : '0 0 196px')};
    overflow: hidden;
    min-width: 200px;

    & .ant-card-head {
        padding: 0 6px;
        min-height: ${({ $compact }) => ($compact ? '15px' : '30px')};
    }

    & .ant-card-head-title {
        padding: ${({ $compact }) => ($compact ? '2px 0' : undefined)};
        font-size: ${({ $compact }) => ($compact ? '12px' : undefined)};
    }

    & .ant-card-body {
        padding: 0;
        ${({ $compact }) => ($compact ? 'display: none;' : '')}
    }

    & .ant-card-extra {
        line-height: 1.2;
    }

    cursor: pointer;
    border: 2px solid
        ${({ $isActive, theme }) => ($isActive ? theme.colorPrimary : theme.colorBorder)};
`

const TableStyled = styled(Table<PrintPlanDateGroup>)`
    border-radius: 5px;
`

interface SummaryOfMachineProps {
    machineBrandName: string
    isActive: boolean
    onClick: () => void
    dateGroups: PrintPlanDateGroup[]
    showStats: boolean
    cancelledCount: number
}

const columns: ColumnsType<PrintPlanDateGroup> = [
    {
        dataIndex: 'dateLabel',
        title: 'Дата',
        width: 58,
        render(_, record) {
            return (
                <Space>
                    <Typography.Text>{record.dayOfWeek}</Typography.Text>
                    <Typography.Text type='secondary'>{record.dateLabel}</Typography.Text>
                </Space>
            )
        },
    },
    {
        dataIndex: 'readyAt',
        title: 'Готовность',
        width: 78,
        render(_, record) {
            return (
                <>
                    <Typography.Text>{dayjs(record.readyAt).format('DD.MM HH:mm')}</Typography.Text>
                    {/* <br />
                    <Typography.Text type='secondary'>
                        старт {dayjs(record.printStartAt).format('DD.MM HH:mm')}
                    </Typography.Text> */}
                </>
            )
        },
    },
    {
        dataIndex: 'jobsCount',
        title: 'Зад. / м²',
        width: 60,
        render(_, record) {
            return (
                <Space>
                    <Typography.Text>{record.jobsCount}</Typography.Text>

                    <Typography.Text type='secondary'>
                        {formatNumber(Math.round(record.totalArea))}
                    </Typography.Text>
                </Space>
            )
        },
    },
]

/**
 * Карточка сводки данных об очереди на конкретном станке
 *
 * @category Component
 * @returns
 */
const SummaryOfMachine: FC<SummaryOfMachineProps> = ({
    machineBrandName,
    isActive,
    onClick,
    dateGroups,
    showStats,
    cancelledCount,
}) => {
    const totalMinutes = dateGroups.reduce((acc, group) => acc + group.totalMinutes, 0)

    return (
        <>
            <CardStyled
                $isActive={isActive}
                $compact={!showStats}
                title={
                    <Space size={4}>
                        {machineBrandName}
                        {cancelledCount > 0 && (
                            <Tooltip title={'Отменены'}>
                                <Badge count={cancelledCount} color={'#f5222d'} />
                            </Tooltip>
                        )}
                    </Space>
                }
                size={'small'}
                extra={
                    showStats ? (
                        <>
                            <Popover
                                title={'Общее время печати'}
                                // content={`+ ${PRINT_PLAN_RESERVE_MINUTES / 60} ч запаса на дату`}
                                placement={'right'}
                            >
                                <div>{formatDuration(totalMinutes)}</div>
                            </Popover>
                            {/* <Popover
                                content={'Дата и время окончания печати всех тиражей'}
                                placement={'right'}
                            >
                                <div>
                                    {lastReadyAt ? dayjs(lastReadyAt).format('DD.MM HH:mm') : ''}
                                </div>
                            </Popover> */}
                        </>
                    ) : undefined
                }
                onClick={onClick}
            >
                {showStats && (
                    <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
                        <TableStyled
                            size={'small'}
                            columns={columns}
                            dataSource={dateGroups}
                            rowKey={'key'}
                            pagination={false}
                        />
                    </ConfigProvider>
                )}
            </CardStyled>
        </>
    )
}

export default memo(SummaryOfMachine)
